/**
 * Created by User on 10/5/2016.
 */
import PageComponent from '../base/PageComponent';

export default class Form extends PageComponent {
    init(){
        this.element.validate();
        this.addEvent('form', 'submit', e => this.validateRecaptcha(e));
    }

    validateRecaptcha(e){
        var captchaField = $(this.element).find('.field.recaptcha'),
            message = captchaField.find('.message.validation');
        if (!$('#g-recaptcha-response').val()) {
            e.preventDefault();

            if (!message.length) {
                captchaField.append('<span class="message validation">Please prove you are not a robot</span>');
            }
        }
        else if (message.length) {
            message.remove();
        }
    }
}


// WEBPACK FOOTER //
// ./javascript/components/Form.js